module.exports = __webpack_public_path__ + "img/cafe_pc_03_v1.f95a0969.png";